import { render, staticRenderFns } from "./WxHistoryWorkList.vue?vue&type=template&id=d21a751e&"
import script from "./WxHistoryWorkList.vue?vue&type=script&lang=js&"
export * from "./WxHistoryWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports